<i class="ant-select-close-icon" *ngIf="!clearIcon; else clearIcon" ui-icon uiSize="xs" uiType="close-circle" uiTheme="fill"></i>
